'use strict';

var Decorator = require('utils/decoration');
var Validator = require('utils/validation');
var utils = require('components/common/utils');

var AbstractFormView = Backbone.Marionette.LayoutView.extend({
    validationMethods: {
        text: Validator.validateText,
        email: Validator.validateEmail,
        password: Validator.validatePassword,
        number: Validator.validateNumber,
        checkbox: 'checkbox',
        callback: 'callback',
    },

    initialize: function (options) {
        this.errors = options.errors || {};
        this.formData = options.formData || {};
        this.inputFields = options.inputFields || {};
        this.cleanHook = options.cleanHook || function () {};

        // this.inputFields -> dictionary
        // inputID          -> key
        // inputField       -> value
        for (var inputID in this.inputFields) {
            this.updateInputFields(inputID, this.inputFields[inputID]);
        }
        this.delegateEvents();
    },

    updateInputFields: function (inputID, inputField) {
        inputField.event = inputField.event || 'keyup';
        inputField.decoIcon = inputField.decoIcon || '';
        inputField.method = this.validationMethods[inputField.method] || Validator.validateText;
        inputField.min = inputField.min != undefined ? inputField.min : 1;
        inputField.max = inputField.max != undefined ? inputField.max : Number.MAX_SAFE_INTEGER;
        inputField.regexp = inputField.regexp || RegExp('.*', 'i');
        inputField.validIfNotVisible = inputField.validIfNotVisible || false;

        this.events[inputField.event + ' #' + inputID + '-input'] = 'clean';
        this.inputFields[inputID] = inputField;
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.errors = this.errors;
        data.formData = this.formData;
        return data;
    },

    decorate: function ($element, icon, color) {
        if (icon) {
            Decorator.addInputDecoration($element, icon, color);
        }
    },

    clean: function (event) {
        var $element = $(event.target);
        Decorator.removeInputDecoration($element);
        $('#' + $element.attr('id').replace('input', 'error')).remove();
        Decorator.cleanupErrors($element);
        this.validate($element);
        this.cleanHook($element);
    },

    validate: function ($element) {
        var input = this.inputFields[$element.attr('id').replace('-input', '')];
        var val = $element.val();
        var valid = false;
        if (input.method === Validator.validatePassword) {
            var validationErrors = input.method(val, input.min, input.regexp);
            var passwordConstraints = {};
            passwordConstraints.length = !_.contains(validationErrors, Validator.ErrorCodes.TooShort);
            passwordConstraints.cases = !_.contains(validationErrors, Validator.ErrorCodes.NoCases);
            passwordConstraints.number = !_.contains(validationErrors, Validator.ErrorCodes.NoNumber);
            passwordConstraints.specialChar = !_.contains(validationErrors, Validator.ErrorCodes.NoSpecChars);
            if (validationErrors.length > 1 || !passwordConstraints.length) {
                this.decorate($element, '', 'has-error');
                valid = false;
            } else {
                this.decorate($element, input.decoIcon, 'has-success');
                valid = true;
            }
            utils.showPasswordHintPopover($element, passwordConstraints, valid);
        } else if ($element.attr('type') === 'checkbox') {
            valid = $element.prop('checked');
        } else if (input.method === 'callback') {
            valid = input.validationCB(val);
        } else {
            var results =
                input.method === Validator.validateNumber
                    ? input.method(val, input.min, input.max)
                    : input.method(val, input.min, input.regexp);

            if (input.error) {
                Decorator.removeValidationErrorMessages($element, input.error.id);
            }

            if (results.length === 0) {
                this.decorate($element, input.decoIcon, 'has-success');
                valid = true;
            } else {
                this.decorate($element, '', 'has-error');
                if (input.error) {
                    Decorator.addValidationErrorMessages($element, input.error.id, [input.error.message]);
                }

                valid = false;
            }
        }
        return valid;
    },

    allFieldsValid: function () {
        var allFieldsValid = true;
        for (var input in this.inputFields) {
            var $element = $('#' + input + '-input');
            if ($element.length == 0) {
                allFieldsValid = allFieldsValid && this.inputFields[input].validIfNotVisible;
                continue;
            }
            if (!this.validate($element)) {
                allFieldsValid = false;
                this.inputFields[input].flashThis
                    ? Decorator.flash(this.inputFields[input].flashThis())
                    : Decorator.flash($element);
            }
        }
        return allFieldsValid;
    },
});

module.exports = AbstractFormView;
